/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 *
 */

import api from '@/config/api'
import vuex from '@/store'
import catchErrors from './catchErrors'
import resolveStationId from '@/utils/resolveStationId'

export default {
  getGroupsByStations(stations = []) {
    let params = { stations, include: 'roles' }
    return catchErrors.get(`/v2/newsdesk/workspace/groups`, {
      params,
      cache: {
        maxAge: 1000
      }
    })
  },
  getAllGroups(station) {
    const stationId = resolveStationId(station)
    if (!stationId) return []
    let params = { include: 'roles,stations' }
    return catchErrors.get(`/v2/newsdesk/groups`, { params: { ...params, 'filter[station_id][]': stationId } })
  },
  createGroup(name, station) {
    const stationId = resolveStationId(station)
    let formData = new FormData()
    formData.append('name', name)
    return catchErrors.post(`/v2/newsdesk/groups`, formData, {
      params: { 'filter[station_id][]': stationId },
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      },
      raxConfig: {
        retry: 5
      }
    })
  },
  async editGroup(id, data) {
    let payload = {
      name: data.name,
      roles: data.roles
    }
    let resp = await catchErrors.patch(`/v2/newsdesk/groups/${id}`, payload)
    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  async deleteGroup(id) {
    let resp = await catchErrors.delete(`/v2/newsdesk/groups/${id}`)
    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  getGroup(id, station) {
    return catchErrors.get(`/v2/newsdesk/groups/${id}`)
  },
  async addStationToGroups(station, groupIds) {
    const stationId = resolveStationId(station)
    let formData = new FormData()
    groupIds.forEach((groupId) => {
      formData.append('group_id[]', groupId)
    })
    let resp = await catchErrors.post(`/v2/newsdesk/workspace/groups/attach`, formData, {
      params: { 'filter[station_id][]': stationId },
      raxConfig: {
        retry: 2
      }
    })

    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  },
  async removeStationFromGroups(station, groupIds) {
    const stationId = resolveStationId(station)
    let formData = new FormData()
    groupIds.forEach((groupId) => {
      formData.append('group_id[]', groupId)
    })
    let resp = await catchErrors.post(`/v2/newsdesk/workspace/groups/detach`, formData, {
      params: { 'filter[station_id][]': stationId },
      headers: {
        'Content-Type': 'multipart/form-data;charset=utf-8'
      },
      raxConfig: {
        retry: 2
      }
    })

    if (resp.data.success === false) throw new Error(resp.data.msg)
    return resp
  }
}
